import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Configuração temporária do Firebase para desenvolvimento
// Em produção, use variáveis de ambiente
const firebaseConfig = {
  apiKey: "AIzaSyDRhmoYyf7DCV5OoE5kIcb3hsMJip6kIu4",
  authDomain: "bynnorgestaodecampo.firebaseapp.com",
  projectId: "bynnorgestaodecampo",
  storageBucket: "bynnorgestaodecampo.firebasestorage.app",
  messagingSenderId: "553675644974",
  appId: "1:553675644974:web:d425ba02ea479a7c31ffbf"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export default app;
